import React from 'react';
import { useRecoilValue, useSetRecoilState, useResetRecoilState } from 'recoil';
import '../../../../../../styles/global.css';
import { Icon, Label } from '@nooz-optics/nooz-components-lib';
import {
  productState,
  staticProductState,
  variantState,
} from '../../../../../../utils/recoil/product';
import { Link } from '../../../../../UI/Elements/Link';
import { Radio } from '../../../../../UI/Elements/Radio/radio';
import {
  formatContentfulComponentProps,
  returnCurrencyCharFromCode,
  returnShopifyVariant,
} from '../../../../../../utils/globals';
import { ProductMainDiopterPicker } from '../DiopterPicker/ProductMainDiopterPicker';

const ProductMainOptionOptin = ({ color, label, icon, diopterPicker }) => {
  const variant = useRecoilValue(variantState);
  const resetVariant = useResetRecoilState(variantState);
  const product = useRecoilValue(productState);
  const setProduct = useSetRecoilState(productState);
  const staticProduct = useRecoilValue(staticProductState);

  const category = product?.categories && product?.categories[0];

  const shopifyProductOptionVariant =
    variant &&
    returnShopifyVariant(variant?.option?.fields?.shopifyData, variant);

  const shopifyMainProduct =
    product && returnShopifyVariant(product?.fields?.shopifyData, variant);

  const currency =
    shopifyProductOptionVariant &&
    returnCurrencyCharFromCode(
      shopifyProductOptionVariant[0]?.priceV2?.currencyCode
    );

  // Calculate the extra cost of the option
  const returnOptionPrice = () => {
    if (shopifyProductOptionVariant && shopifyMainProduct) {
      const productPrice = Number(shopifyMainProduct[0]?.priceV2?.amount);
      const productWithOptionPrice = Number(
        shopifyProductOptionVariant[0]?.priceV2?.amount
      );
      // Cost of the option
      const optionPrice = productWithOptionPrice - productPrice;
      const roundedOptionPrice = Math.round(optionPrice * 100) / 100;
      // check if the cost of the option is <= 0
      if (!optionPrice || optionPrice < 0) {
        return null;
      }
      return roundedOptionPrice.toString();
    }
  };

  const onClick = () => {
    setProduct({
      ...product,
      ...(!product.isOptionCheck ? variant.option : staticProduct),
      isOptionCheck: !product.isOptionCheck,
    });
    // resetVariant();
  };

  const disclosureButton = (
    <button
      className='w-full h-full flex'
      type='button'
      onClick={onClick}>
      <div className='w-full flex items-center justify-between'>
        <div className='flex w-10 items-center'>
          <Icon
            {...icon}
            size='2xl'
            color={color}
          />
        </div>
        <div className='flex w-full justify-between text-left items-start pl-5'>
          <Label
            {...label}
            text={`${label?.text}`}
            type='span'
            weight='normal'
            size='base'
          />
          {returnOptionPrice() > 0 ? (
            <Label
              {...label}
              text={`+${returnOptionPrice()}${currency || ''}`}
              type='span'
              weight='bold'
              size='base'
            />
          ) : null}
        </div>
      </div>
    </button>
  );

  return (
    <div
      className={`border px-5 py-4 transform duration-500  border-gray-400 hover:border-black cursor-pointer ${
        product?.isOptionCheck && `border-${color.classname}`
      } bg-white`}>
      {disclosureButton}
      {product?.isOptionCheck && diopterPicker && (
        <div className='border-t mt-4'>
          <ProductMainDiopterPicker
            variant={variant}
            category={category}
            {...formatContentfulComponentProps(diopterPicker)}
          />
        </div>
      )}
    </div>
  );
};

export const ProductMainOptions: React.FC<ProductMainOptionsProps> = ({
  color,
  variants,
  label,
  link,
  optin,
  diopterPicker,
}) => (
  <div className='w-full pb-4 border-b border-t'>
    <div className='my-3'>
      <Label
        {...label}
        color={{ classname: 'gray-800' }}
        weight='medium'
      />
      <Link
        {...link}
        label={{
          ...link?.label,
          decoration: 'underline',
          size: 'sm',
          weight: 'base',
        }}
      />
    </div>
    <ProductMainOptionOptin
      color={color}
      variants={variants}
      {...formatContentfulComponentProps(optin)}
      diopterPicker={diopterPicker}
    />
  </div>
);
